<template>
  <div class="index">
    <right-content />
  </div>
</template>

<script>
import RightContent from "@/components/Layout/RightContent.vue";
export default {
  components: {
    RightContent
  }
};
</script>

<style lang="less" scoped>
.index {
  height: 100%;
  display: flex;
  overflow: hidden;
}
</style>